import { NetworkResponse } from "~/app/type/common";
import { RequisiteIProps, UpdateRequisiteIProps } from "../model/schema";
import { requestREST } from "~/client/http/CommonHTTP";

const requisiteServiceMap = {
  getList: "/vaz/requisites",
  getActiveList: "/vaz/requisites/active",
  getById: "/vaz/requisites/",
  create: "/vaz/requisites",
  activate: "/vaz/requisites/activate",
  deactivate: "/vaz/requisites/deactivate",
  update: "/vaz/requisites/",
  delete: "/vaz/requisites/",
};

export class AvtovazRequisites {
  static GET = {
    getList: (): NetworkResponse<RequisiteIProps[]> =>
      requestREST.get(requisiteServiceMap.getList),

    getActiveList: (): NetworkResponse<RequisiteIProps[]> =>
      requestREST.get(requisiteServiceMap.getActiveList),
    getById: (id: string) => requestREST.get(requisiteServiceMap.getById + id),
  };
  static POST = {
    create: (data: RequisiteIProps): NetworkResponse<RequisiteIProps> => {
      return requestREST.post(requisiteServiceMap.create, data);
    },
    activate: (id: number): NetworkResponse<boolean> => {
      return requestREST.post(requisiteServiceMap.activate, { id });
    },
    deactivate: (id: number): NetworkResponse<boolean> => {
      return requestREST.post(requisiteServiceMap.deactivate, { id });
    },
  };
  static PUT = {
    update: ({ data, id }): NetworkResponse<RequisiteIProps> => {
      return requestREST.put(requisiteServiceMap.update + id, data);
    },
  };
  static DELETE = {
    delete: (id: number) => requestREST.delete(requisiteServiceMap.delete + id),
  };
}
